import Vue from 'vue';

import App from './App';

import router from './router';
import store from './store';

import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';

import VeeValidate from 'vee-validate';
import VueClipboards from 'vue-clipboards';

import fontawesome from '@fortawesome/fontawesome';
import { faApple, faWindows } from '@fortawesome/fontawesome-free-brands';
import { faClipboard } from '@fortawesome/fontawesome-free-solid';

import './assets/css/util.css';
import './assets/css/main.css';
import './assets/css/material-design-iconic-font.min.css';

fontawesome.library.add(faApple, faWindows, faClipboard);

// loads the Icon plugin
UIkit.use(Icons);

Vue.use(VueClipboards);
Vue.use(VeeValidate, { delay: 1000 });

Vue.directive('focus', {
  inserted(el, binding) {
    if (binding.value) el.focus();
  }
});

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router,
  store
});



// WEBPACK FOOTER //
// ./src/main.js